export enum PageName {
  DAC = 'dac'
}
